/*eslint-disable*/

import { useState, useEffect, useContext } from 'react';
import SectionHeader from '../../SectionHeader';
import PersonalHeader from '../../PersonalDetails/components/header';
import fields from '../fields';
import personalCardIcon from '../../../assets/images/personalcard.png';
import rightArrowIcon from '../../../assets/images/rightarrow.png';
import { ReactComponent as InfoIcon } from '../../../assets/images/personCard.svg';
import { ReactComponent as ScheduleIcon } from '../../../assets/images/schedule.svg';
import { ReactComponent as PDFIcon } from '../../../assets/images/pdf.svg';
import SendSMS from './sms';
import Reports from './info';
import MedicalInfo from './medicalInfo';
import UpdatingBloodTests from './bloodTest';
import SurveyTestForm from '../../Survey/surveyTestForm';
import Schedule from './schedule';
import Shop from './shop';
import TableComponent from '../../TableComponent';
import BasicDrawer from 'components/Drawer';
import useFetchData from '../../../hooks/useFetchData';
import CustomerDetails from './details';
import ResetPassword from './resetpassword';
import Stepper from '../../Stepper';
import { useParams } from 'react-router-dom';
import GlobalContext from '../../../contexts';
import config from '../../../config';
import moment from 'moment';
import BasicModal from './Modal/basic-modal';
import translating from '../translate.json';
import QuestionnairePage from 'Questionnaires/questionnaire-page';
import '../style.scss';
import Button from 'components/Button';
import BasicDialog from 'components/Dialog';
import usePostData from 'hooks/usePostData';
import SnackBar from 'components/SnackBar';
import { SurveyMeasures } from 'components/Survey/Surveymeasures';
import { SurveySummery } from 'components/Survey/medicalSummery';
import enumTherapistsType from 'enums/enum-therapists-type';
import { getAppointmentHeaderText } from './helpers';
import { PrediabetesMeasures } from 'components/Prediabetes/measures';
import { PrediabetesSummery } from 'components/Prediabetes/medicalSummery';
import { GeneralMedicalSummery } from 'components/Prediabetes/GeneralSummery';

const CustomerPage = () => {
  const {
    setSteppersData,
    clientProductStageId,
    setLink,
    currentCustomer,
    setCurrentCustomer,
    currentUser,
    currentProduct,
    setCurrentProduct,
    categoriesList,
  } = useContext(GlobalContext);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [productsList, setProductsList] = useState();
  const [clientProductId, setClientProductId] = useState();
  const [clientProductUuid, setClientProductUuid] = useState();
  const { deliveryHost, appointmentHost } = config;
  const { id } = useParams();
  const [deliveryUrl, setDeliveryUrl] = useState();
  const [appointmentUrl, setAppointmentUrl] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [openMediaclInfo, setOpenMediaclInfo] = useState(false);
  const {
    postData: disableProductPost,
    res: disableProductRes,
    error: disableProductError,
  } = usePostData();
  const {
    postData: activateProductPost,
    res: activateProductRes,
    error: activateProductError,
  } = usePostData();
  const { res: updateRejectedSampleRes, postData: updateRejectedSample } =
    usePostData();
  const [dialogTitle, setDialogTitle] = useState();
  const [dialogDescription, setDialogDescription] = useState();
  let { data: personalDetailsData } = useFetchData('client', id);
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [openModalChangeStatus, setOpenModalChangeStatus] = useState();
  const [appointmentHeaderText, setAppointmentHeaderText] = useState();
  const roleUser = currentUser.role.name;
  const allowdRules = ['Admin', 'Sales', 'Manager', 'Service'];
  const allowdUser = allowdRules.indexOf(roleUser) > -1;
  const addProduct = allowdUser
    ? { handleClick: () => setOpenDrawer('shop'), txt: translating.addProduct }
    : {};
  const tor4uOrganizationServiceId =
    currentCustomer?.organization?.tor4uServiceId;

  const viewPersonalData = (personalDetailsData) => {
    let clientDetails = { ...personalDetailsData };
    let addressData = clientDetails?.address;
    if (addressData) {
      addressData = addressData.split(',');
      clientDetails.city = addressData[0];
      clientDetails.street = addressData[1];
      clientDetails.buildingNumber = addressData[2];
      clientDetails.apartmentNumber = addressData[3];
    }
    clientDetails.date_of_birth = moment(clientDetails.date_of_birth).format(
      'DD.MM.YYYY'
    );
    const [dobSplitted] = clientDetails.date_of_birth.split('.');
    const formattedDob = `${dobSplitted[2]}-${dobSplitted[1]}-${dobSplitted[0]}`;
    const age = moment().diff(formattedDob, 'years');
    clientDetails.age = age;
    setCurrentCustomer(clientDetails);
  };

  useEffect(() => {
    if (
      (disableProductRes?.affected === 1 ||
        activateProductRes?.affected === 1) &&
      !disableProductError &&
      !activateProductError
    ) {
      window.location.reload();
    }
  }, [
    disableProductRes,
    disableProductError,
    activateProductRes,
    activateProductError,
  ]);

  const changeProductActivation = () => {
    if (currentProduct.isActive)
      disableProductPost(
        `client-product/${currentProduct.client_product_uuid}/${
          currentProduct.parentId === 0
            ? currentProduct.productId
            : currentProduct.parentId
        }`,
        {},
        'delete'
      );
    else
      activateProductPost(
        `client-product/activatClientProduct/${
          currentProduct.client_product_uuid
        }/${
          currentProduct.parentId === 0
            ? currentProduct.productId
            : currentProduct.parentId
        }`,
        {},
        'patch'
      );
  };

  useEffect(() => {
    viewPersonalData(personalDetailsData);
  }, [personalDetailsData]);

  let { res: customerProducts } = usePostData(`client-product/${id}`, {});

  const { data: steppersData } = useFetchData('product-status');

  useEffect(() => {
    setSteppersData(steppersData);
  }, [steppersData]);

  useEffect(() => {
    if (customerProducts?.length) {
      let products = [];
      customerProducts?.forEach((p) => {
        products.push({
          clientProductId: p.id,
          client_product_uuid: p.client_product_uuid,
          name: p.product?.name,
          quantity: p.quantity,
          productId: p.productId,
          status: p.status?.text,
          statusId: p.status?.id,
          price: p.finalPrice,
          createdAt: p.createdAt,
          isActive: p.isActive,
          parentId: p.product.parentId,
          numberOfAppointments: p.numberOfAppointments,
          scheduledAppoitments: p.scheduledAppoitments,
          staffId: p.staffId,
          categoryId: p.product.categoryId,
          agree: p.cps?.[0]?.status,
          genResultsDate: p.genResultsDate?.[0],
          disqualifiedSamples: p.disqualifiedSamples,
        });
      });
      setProductsList(products);
    }
  }, [customerProducts]);

  useEffect(() => {
    console.log(currentCustomer);
  }, []);

  const handleSchedule = (info) => {
    const orderNumber = 'id' + Math.random().toString(16).slice(2);
    sessionStorage.setItem('deliveryProductId', info.clientProductId);
    sessionStorage.setItem('deliveryProductStageId', 0);
    const splitAddress = currentCustomer?.address?.split(',') || [];
    setDeliveryUrl(`${deliveryHost}?
        City=${splitAddress[0]}
        &Street=${splitAddress[1]}
        &BuildingNum=${splitAddress[2]}
        &Entrance=${splitAddress[3]}
        &Floor=
        &Zipcode=
        &Phone=${currentCustomer?.mobile}
        &Mail=${currentCustomer?.email}
        &Ssn=${currentCustomer?.ssn}
        &AddressComments=
        &Name=${currentCustomer.first_name} ${currentCustomer.last_name}
        &OrderNumber=${orderNumber}
        &Server=${location.origin}/confirm`);
  };

  const productsTableHeader = [
    translating.productName,
    translating.status,
    translating.purchaseDate,
    '',
    '',
  ];

  const productsColumns = [
    { name: 'name', width: '80px', height: '90px' },
    { name: 'status', width: '40px', height: '90px' },
    { name: 'createdAt', format: 'dateWithHeader', height: '90px' },
    { name: Stepper, format: 'stepper', height: '90px' },
    {
      icon: true,
      format: 'actionsRequiredByStatus',
      name: 'statusId',
      actions: [
        {
          name: 'info',
          icon: InfoIcon,
          handleClick: (cp) => {
            setCurrentProduct(cp);
            setClientProductId(cp?.clientProductId);
            setClientProductUuid(cp?.client_product_uuid);
            setOpenDrawer('info');
          },
          label: 'מידע נוסף',
        },
        {
          name: 'undo',
          icon: InfoIcon,
          handleClick: (cp) => {
            setCurrentProduct(cp);
            setDialogTitle(translating.removeProductTitle);
            setDialogDescription(translating.removeProductDescription);
            setOpenModal(true);
          },
          label: translating.undo,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'play',
          icon: InfoIcon,
          handleClick: (cp) => {
            setCurrentProduct(cp);
            setDialogTitle(translating.activeProductTitle);
            setDialogDescription(translating.activeProductDescription);
            setOpenModal(true);
          },
          label: translating.play,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'schedulePickup',
          icon: ScheduleIcon,
          handleClick: (info) => handleSchedule(info),
          label: translating.schedulePickup,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'scheduleCoach',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            let appointmetUrlString = appointmentHost;
            let mobile = `${currentCustomer.mobile}`;
            const examerType = categoriesList.find(
              (type) => type.name === enumTherapistsType.coach
            )?.id;
            appointmetUrlString += `&serviceId=${examerType}`;
            appointmetUrlString += `&cf1=${cp.clientProductId}&cf3=${currentCustomer.id}&fn=${currentCustomer.first_name}&ln=${currentCustomer.last_name}&pn=${mobile}`;
            setAppointmentUrl(appointmetUrlString);
            console.log('examerType', examerType);
            setAppointmentHeaderText(
              getAppointmentHeaderText({ examerType: enumTherapistsType.coach })
            );
          },
          label: translating.scheduleCoach,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'scheduleDoctor',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            let appointmetUrlString = appointmentHost;
            let mobile = `${currentCustomer.mobile}`;
            const examerType = categoriesList.find(
              (type) => type.name === enumTherapistsType.doctor
            )?.id;
            appointmetUrlString += `&serviceId=${examerType}`;
            appointmetUrlString += `&cf1=${cp.clientProductId}&cf3=${currentCustomer.id}&fn=${currentCustomer.first_name}&ln=${currentCustomer.last_name}&pn=${mobile}`;
            setAppointmentHeaderText(
              getAppointmentHeaderText({
                examerType: enumTherapistsType.doctor,
              })
            );
            setAppointmentUrl(appointmetUrlString);
          },
          label: 'פגישה עם רופא',
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'medicalSummery',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            setCurrentProduct(cp);
            setOpenDrawer('generalMedicalSummery');
          },
          label: 'סיכום פגישה',
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'scheduleExaminer',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            let appointmetUrlString = appointmentHost;
            let mobile = `${currentCustomer.mobile}`;
            const examerType = categoriesList.find(
              (type) => type.name === enumTherapistsType.examer
            );
            const serviceId = tor4uOrganizationServiceId || examerType.id;

            appointmetUrlString += `&serviceId=${serviceId}`;
            appointmetUrlString += `&cf1=${cp.clientProductId}&cf3=${currentCustomer.id}&fn=${currentCustomer.first_name}&ln=${currentCustomer.last_name}&pn=${mobile}`;
            if (currentCustomer.address) {
              const addressData = currentCustomer.address.split(',');
              appointmetUrlString += `&iwst=${addressData[1]}&iwct=${addressData[0]}&iwanum=${addressData[2]}`;
            }
            setAppointmentHeaderText(
              getAppointmentHeaderText({
                examerType: enumTherapistsType.examer,
              })
            );
            setAppointmentUrl(appointmetUrlString);
          },
          label: translating.scheduleChecker,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },

        {
          name: 'scheduleAppointment',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            let appointmetUrlString = appointmentHost;
            console.log('cliet-product', cp, appointmentHost);
            if (cp.scheduledAppoitments < cp.numberOfAppointments) {
              if (cp.staffId) appointmetUrlString += `&staffid=${cp.staffId}`;
              let mobile = `${currentCustomer.mobile}`;
              const serviceId =
                cp.categoryId == 137577
                  ? tor4uOrganizationServiceId || cp.categoryId
                  : cp.categoryId;
              appointmetUrlString += `&cf1=${cp.clientProductId}&cf3=${currentCustomer.id}&fn=${currentCustomer.first_name}&ln=${currentCustomer.last_name}&pn=${mobile}&serviceId=${serviceId}`;
              setAppointmentUrl(appointmetUrlString);
            } else alert('הלקוח עבר את מכסת הפגישות שנקבעה');
          },
          label: translating.scheduleAppointment,
          roles: ['Admin', 'Sales', 'System', 'Manager'],
        },
        {
          name: 'measures',
          icon: ScheduleIcon,
          handleClick: () => setLink('measures'),
          label: translating.measures,
          roles: [
            'Admin',
            'System',
            'Medical Staff',
            'Manager',
            'Gen Lab',
            'Blood Lab',
            'Service',
          ],
        },
        {
          name: 'pdf',
          icon: PDFIcon,
          handleClick: () => alert('download pdf file'),
        },
        {
          label: translating.activeSample,
          name: 'activeSample',
          icon: ScheduleIcon,
          handleClick: (cp) => {
            setOpenModalChangeStatus(cp.client_product_uuid);
          },
          roles: [
            'Admin',
            'System',
            'Medical Staff',
            'Manager',
            'Gen Lab',
            'Blood Lab',
            'Service',
          ],
        },
      ],
    },
  ];

  const purchasesTableHeader = [
    translating.productName,
    translating.productId,
    translating.purchaseDate,
    translating.productCost,
  ];

  const purchasesColumns = [
    { name: 'name', width: '80px' },
    { name: 'productId' },
    { name: 'createdAt', format: 'date' },
    { name: 'price', format: 'price' },
  ];

  useEffect(() => {
    if (updateRejectedSampleRes?.affected === 1) {
      window.location.reload();
    }
  }, [updateRejectedSampleRes]);

  const updateRejectedSampleFunc = () => {
    updateRejectedSample(
      `client-product/updateRejectedSample/${openModalChangeStatus}/12`,
      {},
      'post'
    );
  };
  return (
    <div className="customer-page">
      {currentCustomer?.id && (
        <div className="wrapper-personal-data">
          <div
            className={`customer-page-right-side ${
              !currentCustomer?.products ? 'has-products' : ''
            }`}
          >
            <div>
              <SectionHeader
                title={`${currentCustomer?.first_name} ${currentCustomer?.last_name}`}
                newItem={addProduct}
              ></SectionHeader>
              <CustomerDetails
                setOpenDrawer={setOpenDrawer}
                fields={fields()}
                data={currentCustomer}
                handleUpdate={(client) => {
                  viewPersonalData(client);
                  setShowSnakbar(true);
                }}
                isActive={customerProducts?.length}
              ></CustomerDetails>
              {productsList?.length && (
                <>
                  <div className="personal-details">
                    <PersonalHeader
                      title={translating.products}
                      data={currentCustomer}
                    ></PersonalHeader>
                    <TableComponent
                      headers={productsTableHeader}
                      hideHeaders={true}
                      columns={productsColumns}
                      rows={productsList}
                    ></TableComponent>
                  </div>
                  {/* {allowdUser && (
                    <div className="personal-details products-list">
                      <div className="purchases-header">
                        <div className="purchases-title">
                          {translating.purchases}
                        </div>
                        <div className="purchases-total">
                          <div className="purchases-amount">
                            סה"כ מוצרים: {productsList.length}
                          </div>
                          <div className="purchases-total">
                            סה"כ תשלומים:{' '}
                            {productsList.reduce((accumulator, object) => {
                              return accumulator + object.price;
                            }, 0)}{' '}
                            ₪
                          </div>
                        </div>
                      </div>
                      <TableComponent
                        headers={purchasesTableHeader}
                        columns={purchasesColumns}
                        rows={productsList}
                      ></TableComponent>
                    </div>
                  )} */}
                </>
              )}
            </div>
          </div>
          <div className="customer-page-left-side">
            {!openDrawer && (
              <div
                className="customer-snapshot"
                onClick={() => setLink('medicalInfo')}
              >
                <img src={rightArrowIcon}></img>
                <img src={personalCardIcon}></img>
                <div className="customer-snapshot-title">
                  {translating.medicalInfo}
                </div>
              </div>
            )}
            <BasicDrawer
              open={openDrawer}
              onClose={() => {
                setOpenDrawer(false);
              }}
              drawerWidth={
                openDrawer === 'surveySummery' ||
                openDrawer === 'surveyMeasures' ||
                openDrawer === 'medicalInfo'
                  ? 'half'
                  : ''
              }
            >
              <div className="wrapper-drawer">
                {(() => {
                  switch (openDrawer) {
                    // case 'medicalInfo':
                    //   return (
                    //     <MedicalInfo
                    //       clientId={id}
                    //       gender={currentCustomer.gender}
                    //     ></MedicalInfo>
                    //   );
                    case 'info':
                      return (
                        <Reports
                          clientProductId={clientProductId}
                          handleChangeMode={setOpenDrawer}
                        ></Reports>
                      );
                    case 'questionnaires':
                      return (
                        <QuestionnairePage
                          clientProductStageId={clientProductStageId}
                          closeDrawer={() => setOpenDrawer(false)}
                        />
                      );
                    case 'bloodTest':
                      return (
                        <UpdatingBloodTests
                          clientProductId={clientProductId}
                          clientProductUuid={clientProductUuid}
                          handleChangeMode={setOpenDrawer}
                        ></UpdatingBloodTests>
                      );
                    case 'surveyMeasures':
                      return (
                        <SurveyMeasures
                          clientProductUuid={clientProductUuid}
                          handleChangeMode={setOpenDrawer}
                        ></SurveyMeasures>
                      );
                    case 'surveySummery':
                      return (
                        <SurveySummery
                          clientProductUuid={clientProductUuid}
                          handleChangeMode={setOpenDrawer}
                        ></SurveySummery>
                      );
                    case 'prediebetesMeasures':
                      return (
                        <PrediabetesMeasures
                          clientProductId={clientProductId}
                          clientProductUuid={clientProductUuid}
                          handleChangeMode={setOpenDrawer}
                        />
                      );
                    case 'prediebetesSummery':
                      return (
                        <PrediabetesSummery
                          clientProductId={clientProductId}
                          clientProductUuid={clientProductUuid}
                          handleChangeMode={setOpenDrawer}
                        ></PrediabetesSummery>
                      );
                    case 'sendSMS':
                      return (
                        <SendSMS
                          mobile={personalDetailsData?.mobile}
                          email={personalDetailsData?.email}
                          handleChangeMode={setOpenDrawer}
                        ></SendSMS>
                      );
                    case 'resetPassword':
                      return (
                        <ResetPassword
                          mobile={personalDetailsData?.mobile}
                          email={personalDetailsData?.email}
                          handleChangeMode={setOpenDrawer}
                        ></ResetPassword>
                      );
                    case 'schedule':
                      return <Schedule></Schedule>;
                    case 'shop':
                      return (
                        <Shop
                          handleChangeMode={setOpenDrawer}
                          organizationId={personalDetailsData?.organizationId}
                        ></Shop>
                      );
                    case 'generalMedicalSummery':
                      return (
                        <GeneralMedicalSummery
                          closeDrawer={() => setOpenDrawer(false)}
                        />
                      );
                  }
                })()}
              </div>
            </BasicDrawer>
          </div>
        </div>
      )}
      {openMediaclInfo && (
        <MedicalInfo
          clientId={id}
          gender={currentCustomer.gender}
        ></MedicalInfo>
      )}
      {openModal && (
        <BasicDialog
          title={dialogTitle}
          description={`${dialogDescription} ${currentProduct.name} ללקוח ${currentCustomer.first_name} ${currentCustomer.last_name}`}
          handleClose={() => {
            setCurrentProduct(null);
            setOpenModal(false);
          }}
          handleSubmit={changeProductActivation}
        ></BasicDialog>
      )}
      {openModalChangeStatus && (
        <BasicDialog
          title={'אפשר תיאום חוזר'}
          description={`האם אתה בטוח שאתה רוצה לאפשר תיאום חוזר`}
          handleClose={() => {
            setOpenModalChangeStatus(null);
          }}
          handleSubmit={updateRejectedSampleFunc}
        ></BasicDialog>
      )}
      {deliveryUrl && (
        <BasicModal
          width={800}
          height={`80%`}
          handleClose={() => setDeliveryUrl(null)}
        >
          <iframe className="delivery-iframe" src={deliveryUrl}></iframe>
          <div className="modal-wrapper-btn">
            <Button
              id="close-moadl"
              txt="סגור"
              handleClick={() => setDeliveryUrl(null)}
            ></Button>
          </div>
        </BasicModal>
      )}
      {appointmentUrl && (
        <BasicModal
          width={800}
          height="80%"
          handleClose={() => {
            setAppointmentUrl(null);
            window.location.reload();
          }}
        >
          <div>{appointmentHeaderText}</div>
          <iframe className="delivery-iframe" src={appointmentUrl}></iframe>
          <div className="modal-wrapper-btn">
            <Button
              id="close-moadl"
              txt="סגור"
              handleClick={() => {
                window.location.reload();
              }}
            ></Button>
          </div>
        </BasicModal>
      )}
      {showSnackbar && (
        <SnackBar
          msg={'לקוח עודכן'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default CustomerPage;
